import { FC } from 'react';
import { Col, Row, Skeleton } from 'antd';
import './styles.scss';

const AssetEditLoadingFormTemplate: FC = () => {
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} sm={9}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={9}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={6}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={11}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={5}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={8}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={8}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={16}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={12}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={12}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={12}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
        <Col xs={24} sm={24}>
          <div className={'AssetEditLoadingFormTemplate__block'}>
            <Skeleton.Input className={'AssetEditLoadingFormTemplate__skeleton'} active></Skeleton.Input>
          </div>
        </Col>
      </Row>
      <div className={'AssetEditLoadingFormTemplate__text'}>
        <Skeleton.Input active className={'AssetEditLoadingFormTemplate__skeleton'}></Skeleton.Input>
      </div>
      <div className={'AssetEditLoadingFormTemplate__text'}>
        <Skeleton.Input active className={'AssetEditLoadingFormTemplate__skeleton'}></Skeleton.Input>
      </div>
    </>
  );
};

export default AssetEditLoadingFormTemplate;
